import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import snakeCase from 'lodash/snakeCase'
import { Paths } from '../screens/Organization/constants'
import { useAnalytics } from './useAnalytics'
import {
  PREVIOUS_STEP_KEY,
  QUALIFIED_TEAM_KEY,
  getItemSafe,
  setItemSafe,
} from '../helpers/localStorage'

export function useProvideStepAnalytics(path: Paths) {
  const step = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state) => (state as any).organization[path.toLowerCase()].step
  )
  const track = useAnalytics()
  const sendEvent = useCallback(
    (step: string) => {
      const previousStep = getItemSafe(PREVIOUS_STEP_KEY) || ''

      const eventTrackName = [
        'ONBOARDING',
        `${path.toUpperCase()}`,
        `${snakeCase(step).toUpperCase()}`,
      ].join('_')

      /* console.debug(
        `slite-boarding-analytics - ${eventTrackName} from ${previousStep}`
      ) */
      const qualifiedTeam = getItemSafe(QUALIFIED_TEAM_KEY) || ''

      track(eventTrackName, {
        fromOnboardingStep: previousStep,
        qualifiedTeam,
      })

      setItemSafe(PREVIOUS_STEP_KEY, eventTrackName)
    },
    [path, track]
  )

  useEffect(() => {
    sendEvent(step)
  }, [sendEvent, step])
}
